import { Modal } from "antd";
import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { ExpandAltOutlined } from "@ant-design/icons";

//STYLES
import { PG } from "./style";

//APP
import { transition_default } from "../../../../../../utils";

//COMPONENTS
import { DefaultTitle } from "../defaultTitle";
import { DonutChartSvg } from "./components/chart";

//PROPS
interface Props {
    dados_progresso: [number, number, number];
    segmento: string;
}

//CONST
const segmento_permitido = ['', 'Todos', 'Atividades'];

export const ProgressoGeral: React.FC<Props> = ({ dados_progresso, segmento }) => {

    const [modalAberto, setModalAberto] = useState(false);

    return (
        <AnimatePresence>
            {segmento_permitido.includes(segmento) && (
                <PG
                    layout
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ y: 90, opacity: 0, transition: { delay: 0, ease: [0, 0.71, 0.2, 1.01] } }}
                    transition={{ ...transition_default }}
                    key={'progresso_geral'}
                >
                    <DefaultTitle title="Progresso Geral" />
                    <ExpandAltOutlined
                        onClick={() => setModalAberto(true)}
                        style={{
                            fontSize: 14,
                            cursor: 'pointer',
                            color: '#999',
                            padding: 4,
                            borderRadius: 4,
                            transition: 'color 0.2s',
                            position: 'absolute',
                            right: 10,
                            top: 10
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.color = '#555')}
                        onMouseLeave={(e) => (e.currentTarget.style.color = '#999')}
                    />

                    <div className="PG__chart">
                        <DonutChartSvg values={dados_progresso} />
                    </div>

                    <div className="PG__labels">
                        <div className="PG__labels__item">
                            <div className="PG__labels__item__circle" style={{ background: "#7ebd61" }} />
                            <span className="PG__labels__item__lebel">Concluído</span>
                        </div>
                        <div className="PG__labels__item">
                            <div className="PG__labels__item__circle" />
                            <span className="PG__labels__item__lebel">Em progresso</span>
                        </div>
                        <div className="PG__labels__item">
                            <div className="PG__labels__item__circle" style={{ background: "#F5F5F5" }} />
                            <span className="PG__labels__item__lebel">Não iniciado</span>
                        </div>
                    </div>

                    <Modal
                        open={modalAberto}
                        onCancel={() => setModalAberto(false)}
                        footer={null}
                        title="Progresso Geral"
                        width={500}
                        centered
                    >
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '20px 0' }}>
                            <DonutChartSvg values={dados_progresso} size={250} />
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', gap: 20, paddingBottom: 10 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#7ebd61' }} />
                                <span>Concluído</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                <div style={{ width: 10, height: 10, borderRadius: '50%', background: 'var(--primary-color)' }} />
                                <span>Em progresso</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#F5F5F5' }} />
                                <span>Não iniciado</span>
                            </div>
                        </div>
                    </Modal>

                </PG>
            )}
        </AnimatePresence>
    )
};